import React, { useState, useEffect } from 'react';
import cns from 'classnames';
import { PrimaryButton, SecondaryButton } from 'components/index';
import { FormattedMessage } from '../../../../util/reactIntl';
import { createResourceLocatorString } from '../../../../util/routes';
import PriceFilterSimple from '../../../PriceFilter/PriceFilterSimple';
import routeConfiguration from '../../../../routeConfiguration';
import { omit } from 'lodash';

import css from './FilterDropdown.css';

const RADIX = 10;

function FilterDropdown(props) {
  const { redirectPageName, urlQueryParams, priceFilter, languageFilter, history } = props;

  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [isFilterPanelOpen, setFilterPanelOpen] = useState(false);
  const [priceRange, setPriceRange] = useState(null);
  // const [listingsModeValue, setListingModeValuel] = useState({ listingsModeValue: 'in_person' });

  useEffect(() => {
    if (urlQueryParams && urlQueryParams.pub_hosted_in) {
      setSelectedLanguages(
        Array.isArray(urlQueryParams.pub_hosted_in)
          ? urlQueryParams.pub_hosted_in
          : urlQueryParams.pub_hosted_in.split(',')
      );
    }
  }, [urlQueryParams]);

  //   const onClickModeItemHandler = value => {
  //     const { history } = props;
  //     const urlParams = parse(history.location.search);
  //     let queryParams = { ...urlParams, pub_listing_mode: value };
  //     setListingModeValuel({ listingsModeValue: value });
  //     history.push(
  //       createResourceLocatorString('BookListingPromo', routeConfiguration(), {}, queryParams)
  //     );
  //   };

  const onClickAdvancedFilterApplyHandler = () => {
    let queryParams = {
      ...urlQueryParams,
      [languageFilter.paramName]: selectedLanguages,
      [priceFilter.paramName]: priceRange,
    };
    setFilterPanelOpen(false);
    history.push(
      createResourceLocatorString(redirectPageName, routeConfiguration(), {}, queryParams)
    );
  };

  const onClickAdvancedFilterResetHandler = () => {
    const queryParams = omit(urlQueryParams, ['price', 'pub_hosted_in']);
    setSelectedLanguages([]);
    setPriceRange(null);
    setFilterPanelOpen(false);
    history.push(
      createResourceLocatorString(redirectPageName, routeConfiguration(), {}, queryParams)
    );
  };

  const initialPriceRangeValue = (queryParams, paramName) => {
    const price = queryParams[paramName];
    const valuesFromParams = !!price ? price.split(',').map(v => Number.parseInt(v, RADIX)) : [];

    return !!price && valuesFromParams.length === 2
      ? {
          minPrice: valuesFromParams[0],
          maxPrice: valuesFromParams[1],
        }
      : null;
  };

  const initialPriceRange = priceFilter
    ? initialPriceRangeValue(urlQueryParams, priceFilter.paramName)
    : null;

  const handlePrice = (urlParam, range) => {
    const { minPrice, maxPrice } = range || {};

    const priceRangeValue = minPrice != null && maxPrice != null ? `${minPrice},${maxPrice}` : null;
    setPriceRange(priceRangeValue);
  };
  const priceFilterElement = priceFilter ? (
    <PriceFilterSimple
      id="SearchFilters.priceFilter"
      urlParam={priceFilter.paramName}
      onSubmit={handlePrice}
      {...priceFilter.config}
      initialValues={initialPriceRange}
    />
  ) : null;

  //   const listingModeElement = (
  //     <div className={css.modeItems}>
  //       <div
  //         onClick={() => onClickModeItemHandler('in_person')}
  //         className={classNames(
  //           css.modeItem,
  //           listingsModeValue === 'in_person' && css.selectedModeItem
  //         )}
  //       >
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="18"
  //           height="14"
  //           viewBox="0 0 19 15"
  //           fill="none"
  //         >
  //           <path
  //             d="M10.0201 7.83219C10.4686 7.44937 10.8284 6.97588 11.075 6.44386C11.3215 5.91184 11.4491 5.33375 11.4491 4.74881C11.4491 3.64967 11.0063 2.59555 10.2181 1.81834C9.42991 1.04113 8.36088 0.604492 7.24619 0.604492C6.1315 0.604492 5.06246 1.04113 4.27426 1.81834C3.48606 2.59555 3.04325 3.64967 3.04325 4.74881C3.04324 5.33375 3.17085 5.91184 3.41741 6.44386C3.66398 6.97588 4.02373 7.44937 4.47225 7.83219C3.29554 8.35759 2.2972 9.20606 1.59658 10.2761C0.895962 11.3462 0.522722 12.5926 0.521484 13.8663C0.521484 14.0862 0.610046 14.297 0.767687 14.4524C0.925328 14.6079 1.13913 14.6952 1.36207 14.6952C1.58501 14.6952 1.79882 14.6079 1.95646 14.4524C2.1141 14.297 2.20266 14.0862 2.20266 13.8663C2.20266 12.5474 2.73403 11.2824 3.67987 10.3497C4.62572 9.4171 5.90856 8.89314 7.24619 8.89314C8.58381 8.89314 9.86665 9.4171 10.8125 10.3497C11.7583 11.2824 12.2897 12.5474 12.2897 13.8663C12.2897 14.0862 12.3783 14.297 12.5359 14.4524C12.6936 14.6079 12.9074 14.6952 13.1303 14.6952C13.3532 14.6952 13.567 14.6079 13.7247 14.4524C13.8823 14.297 13.9709 14.0862 13.9709 13.8663C13.9697 12.5926 13.5964 11.3462 12.8958 10.2761C12.1952 9.20606 11.1968 8.35759 10.0201 7.83219ZM7.24619 7.23541C6.74743 7.23541 6.25987 7.08957 5.84517 6.81634C5.43047 6.54311 5.10725 6.15476 4.91638 5.70039C4.72551 5.24603 4.67558 4.74606 4.77288 4.2637C4.87018 3.78135 5.11036 3.33828 5.46303 2.99053C5.81571 2.64277 6.26504 2.40595 6.75422 2.31C7.24339 2.21405 7.75043 2.2633 8.21122 2.4515C8.67202 2.63971 9.06586 2.95842 9.34296 3.36734C9.62005 3.77626 9.76795 4.25701 9.76795 4.74881C9.76795 5.4083 9.50226 6.04078 9.02934 6.5071C8.55642 6.97343 7.915 7.23541 7.24619 7.23541ZM15.4335 7.50064C15.9715 6.90331 16.3229 6.16539 16.4454 5.37572C16.568 4.58604 16.4564 3.77828 16.1243 3.04964C15.7921 2.32101 15.2535 1.70257 14.5731 1.26876C13.8928 0.834958 13.0999 0.604279 12.2897 0.604492C12.0668 0.604492 11.853 0.691819 11.6953 0.847261C11.5377 1.0027 11.4491 1.21353 11.4491 1.43336C11.4491 1.65319 11.5377 1.86401 11.6953 2.01945C11.853 2.17489 12.0668 2.26222 12.2897 2.26222C12.9585 2.26222 13.5999 2.5242 14.0729 2.99053C14.5458 3.45685 14.8115 4.08933 14.8115 4.74881C14.8103 5.18417 14.6932 5.61158 14.4719 5.98832C14.2507 6.36505 13.933 6.6779 13.5506 6.89557C13.426 6.96646 13.3219 7.0677 13.2483 7.18961C13.1747 7.31151 13.1341 7.45 13.1303 7.59182C13.1268 7.73253 13.1597 7.87181 13.2258 7.99652C13.292 8.12123 13.3893 8.22727 13.5086 8.30464L13.8364 8.52015L13.9457 8.57817C14.9589 9.05204 15.8137 9.80157 16.4094 10.7385C17.0051 11.6753 17.3169 12.7606 17.308 13.8663C17.308 14.0862 17.3966 14.297 17.5542 14.4524C17.7119 14.6079 17.9257 14.6952 18.1486 14.6952C18.3715 14.6952 18.5854 14.6079 18.743 14.4524C18.9006 14.297 18.9892 14.0862 18.9892 13.8663C18.9961 12.5944 18.673 11.3418 18.0507 10.2277C17.4283 9.11351 16.5274 8.17477 15.4335 7.50064Z"
  //             fill="#B2AEAB"
  //           />
  //         </svg>
  //         <span>In Person</span>
  //       </div>
  //       <div
  //         onClick={() => onClickModeItemHandler('online')}
  //         className={classNames(css.modeItem, listingsModeValue === 'online' && css.selectedModeItem)}
  //       >
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="18"
  //           height="14"
  //           viewBox="0 0 18 15"
  //           fill="none"
  //         >
  //           <path
  //             d="M14.5192 0.604492H2.86058C2.198 0.604492 1.56255 0.847932 1.09403 1.28126C0.625515 1.71458 0.362305 2.3023 0.362305 2.91511V9.07675C0.362305 9.68957 0.625515 10.2773 1.09403 10.7106C1.56255 11.1439 2.198 11.3874 2.86058 11.3874H7.85713V12.9278H4.5261C4.30524 12.9278 4.09342 13.0089 3.93725 13.1534C3.78108 13.2978 3.69334 13.4937 3.69334 13.698C3.69334 13.9023 3.78108 14.0982 3.93725 14.2426C4.09342 14.387 4.30524 14.4682 4.5261 14.4682H12.8537C13.0745 14.4682 13.2864 14.387 13.4425 14.2426C13.5987 14.0982 13.6864 13.9023 13.6864 13.698C13.6864 13.4937 13.5987 13.2978 13.4425 13.1534C13.2864 13.0089 13.0745 12.9278 12.8537 12.9278H9.52265V11.3874H14.5192C15.1818 11.3874 15.8172 11.1439 16.2858 10.7106C16.7543 10.2773 17.0175 9.68957 17.0175 9.07675V2.91511C17.0175 2.3023 16.7543 1.71458 16.2858 1.28126C15.8172 0.847932 15.1818 0.604492 14.5192 0.604492ZM15.352 9.07675C15.352 9.28102 15.2642 9.47693 15.1081 9.62137C14.9519 9.76581 14.7401 9.84696 14.5192 9.84696H2.86058C2.63972 9.84696 2.4279 9.76581 2.27173 9.62137C2.11556 9.47693 2.02782 9.28102 2.02782 9.07675V2.91511C2.02782 2.71084 2.11556 2.51493 2.27173 2.37049C2.4279 2.22605 2.63972 2.1449 2.86058 2.1449H14.5192C14.7401 2.1449 14.9519 2.22605 15.1081 2.37049C15.2642 2.51493 15.352 2.71084 15.352 2.91511V9.07675Z"
  //             fill="#B2AEAB"
  //           />
  //         </svg>
  //         <span>Online</span>
  //       </div>
  //     </div>
  //   );

  const handleLanguage = (urlParam, value) => {
    const updateValue = selectedLanguages;
    if (updateValue.includes(value)) {
      updateValue.splice(updateValue.indexOf(value), 1);
    } else {
      updateValue.push(value);
    }
    setSelectedLanguages(updateValue);
  };

  const languageFilterElement = languageFilter ? (
    <div>
      <h4 className={css.languageTitle}>
        <FormattedMessage id="ModifiedSearchFilters.languageOffered" />
      </h4>
      <div className={css.languageOptionWrapper}>
        {languageFilter.options.map(option => {
          return (
            <div className={css.checkboxContainer} key={option.key}>
              <input
                type="checkbox"
                id={option.key}
                defaultChecked={selectedLanguages.includes(option.key)}
                onChange={() => handleLanguage(languageFilter.paramName, option.key)}
              />
              <label htmlFor={option.key}>{option.label}</label>
            </div>
          );
        })}
      </div>
    </div>
  ) : null;

  return (
    <>
      {/* */}

      <div
        className={cns(css.filterButtonItem, isFilterPanelOpen && css.filterButtonItemOpen)}
        onClick={() => setFilterPanelOpen(prevState => !prevState)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
        >
          <path
            d="M4.18482 10.4998C4.30534 10.1582 4.52883 9.86247 4.8245 9.65326C5.12017 9.44405 5.47345 9.33171 5.83565 9.33171C6.19785 9.33171 6.55113 9.44405 6.8468 9.65326C7.14247 9.86247 7.36597 10.1582 7.48649 10.4998H13.419V11.6665H7.48649C7.36597 12.008 7.14247 12.3038 6.8468 12.513C6.55113 12.7222 6.19785 12.8346 5.83565 12.8346C5.47345 12.8346 5.12017 12.7222 4.8245 12.513C4.52883 12.3038 4.30534 12.008 4.18482 11.6665H1.75232V10.4998H4.18482ZM7.68482 6.41647C7.80534 6.07491 8.02883 5.77914 8.3245 5.56993C8.62017 5.36072 8.97345 5.24837 9.33565 5.24837C9.69785 5.24837 10.0511 5.36072 10.3468 5.56993C10.6425 5.77914 10.866 6.07491 10.9865 6.41647H13.419V7.58314H10.9865C10.866 7.9247 10.6425 8.22047 10.3468 8.42968C10.0511 8.63888 9.69785 8.75123 9.33565 8.75123C8.97345 8.75123 8.62017 8.63888 8.3245 8.42968C8.02883 8.22047 7.80534 7.9247 7.68482 7.58314H1.75232V6.41647H7.68482ZM4.18482 2.33314C4.30534 1.99157 4.52883 1.6958 4.8245 1.4866C5.12017 1.27739 5.47345 1.16504 5.83565 1.16504C6.19785 1.16504 6.55113 1.27739 6.8468 1.4866C7.14247 1.6958 7.36597 1.99157 7.48649 2.33314H13.419V3.4998H7.48649C7.36597 3.84136 7.14247 4.13713 6.8468 4.34634C6.55113 4.55555 6.19785 4.6679 5.83565 4.6679C5.47345 4.6679 5.12017 4.55555 4.8245 4.34634C4.52883 4.13713 4.30534 3.84136 4.18482 3.4998H1.75232V2.33314H4.18482ZM5.83565 3.4998C5.99036 3.4998 6.13874 3.43834 6.24813 3.32895C6.35753 3.21955 6.41899 3.07118 6.41899 2.91647C6.41899 2.76176 6.35753 2.61339 6.24813 2.50399C6.13874 2.39459 5.99036 2.33314 5.83565 2.33314C5.68094 2.33314 5.53257 2.39459 5.42317 2.50399C5.31378 2.61339 5.25232 2.76176 5.25232 2.91647C5.25232 3.07118 5.31378 3.21955 5.42317 3.32895C5.53257 3.43834 5.68094 3.4998 5.83565 3.4998ZM9.33565 7.58314C9.49036 7.58314 9.63873 7.52168 9.74813 7.41228C9.85753 7.30288 9.91899 7.15451 9.91899 6.9998C9.91899 6.84509 9.85753 6.69672 9.74813 6.58732C9.63873 6.47793 9.49036 6.41647 9.33565 6.41647C9.18094 6.41647 9.03257 6.47793 8.92317 6.58732C8.81378 6.69672 8.75232 6.84509 8.75232 6.9998C8.75232 7.15451 8.81378 7.30288 8.92317 7.41228C9.03257 7.52168 9.18094 7.58314 9.33565 7.58314ZM5.83565 11.6665C5.99036 11.6665 6.13874 11.605 6.24813 11.4956C6.35753 11.3862 6.41899 11.2378 6.41899 11.0831C6.41899 10.9284 6.35753 10.7801 6.24813 10.6707C6.13874 10.5613 5.99036 10.4998 5.83565 10.4998C5.68094 10.4998 5.53257 10.5613 5.42317 10.6707C5.31378 10.7801 5.25232 10.9284 5.25232 11.0831C5.25232 11.2378 5.31378 11.3862 5.42317 11.4956C5.53257 11.605 5.68094 11.6665 5.83565 11.6665Z"
            fill="#0095B3"
          />
        </svg>
        <FormattedMessage id={'ModifiedSearchFilters.filters'} />
      </div>

      {isFilterPanelOpen && (
        <div onMouseLeave={() => setFilterPanelOpen(false)} className={css.DropdownFilterPopup}>
          <div className={css.advancedFiltersWrapper}>
            <span className={css.FilterByTitle}>
              <FormattedMessage id="ModifiedSearchFilters.filterBy" />
            </span>
            {priceFilterElement}
            {languageFilterElement}
            {/* {listingModeElement} */}
            <div className={css.filterButtonWrapper}>
              <SecondaryButton
                onClick={onClickAdvancedFilterResetHandler}
                className={css.filterResetButton}
              >
                <FormattedMessage id="ModifiedSearchFilters.reset" />
              </SecondaryButton>
              <PrimaryButton
                onClick={onClickAdvancedFilterApplyHandler}
                className={css.filterApplyButton}
              >
                <FormattedMessage id="ModifiedSearchFilters.apply" />
              </PrimaryButton>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FilterDropdown;
